// extracted by mini-css-extract-plugin
export default {"errorMessageContainer":"ErrorMessage_errorMessageContainer__DfaCF","errorMessage":"ErrorMessage_errorMessage__4OvLD","closeButton":"ErrorMessage_closeButton__zViqN"};